import React from 'react';
import ReactDOM from 'react-dom';
import Index from '../common/HomePage/index';

const componentElm = (typeof document !== 'undefined') &&
    document.querySelector('.pro_homepage_perseus');

if (componentElm) {
    const initialData = window.initialData.pro_homepage_perseus;

    ReactDOM.render(
        <Index {...initialData}/>,
        componentElm
    );
}

if (module.hot) {
    module.hot.accept();
}

export default Index;



// WEBPACK FOOTER //
// ./src/client/HomePage.js